export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/923135224547"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 w-16 h-16 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all z-50 cursor-pointer animate-bounce"
      aria-label="Contact us on WhatsApp"
    >
      <i className="ri-whatsapp-fill text-3xl"></i>
    </a>
  );
}